<div class="CenterGlobalLoader" *ngIf="ShowLoader">
    <div class="GlobalPageLoader">
        <div></div>
        <div></div>
    </div>
</div>